import { render, staticRenderFns } from "./address.vue?vue&type=template&id=0201d3ce"
import script from "./address.vue?vue&type=script&lang=ts"
export * from "./address.vue?vue&type=script&lang=ts"
import style0 from "./address.vue?vue&type=style&index=0&id=0201d3ce&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports